import {
  Link,
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import { GameCanvas } from "./GameCanvas";

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

function Landing(): JSX.Element {
  return (
    <div className="landing">
      <h1>puranjay.me</h1>
      <p>a world to explore</p>
      <Link to="/play" className="play-button">
        Play ▶
      </Link>
    </div>
  );
}

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Landing,
});

const playRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/play",
  component: GameCanvas,
});

const routeTree = rootRoute.addChildren([indexRoute, playRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
